import { pipe, ReadonlyArray } from "fp";

import React from "react";
import styled from "styled-components";

import { useAction } from "~/Action";
import * as Document from "~/Document";
import { Sort, SortDown, SortUp } from "~/Icon";
import * as Layout from "~/Layout";
import * as Table from "~/Table";

const headers = () => [
  { name: "Date", sort: { type: Document.Sort.Type.dateOfCreation() } },
  { name: "Driver", sort: { type: Document.Sort.Type.driver() } },
  { name: "Type", sort: { type: Document.Sort.Type.documentType() } },
  { name: "Reference", sort: { type: Document.Sort.Type.reference() } },
];

export const colSpan = (): number => headers().length;

export const Component: Component = () =>
  pipe(
    Document.Sort.useActive(),

    (active) =>
      pipe(
        headers(),
        ReadonlyArray.map((header) => (
          <Header.Component
            key={header.name}
            {...header}
            sort={{ ...header.sort, active }}
          />
        ))
      ),

    (headers) => (
      <Table.Head.Component>
        <Table.Row.Component>
          {headers}
          <Table.Header.Component />
        </Table.Row.Component>
      </Table.Head.Component>
    )
  );

export namespace Header {
  export type Header = {
    readonly name: string;
    readonly sort: Pick<Document.Sort.Sort, "type"> & {
      readonly active: Document.Sort.Sort;
    };
  };

  export const Component: React.Fn<Header> = ({ name, sort }) => {
    const { create } = Document.Sort.Action.Updated;
    return (
      <Style onClick={useAction(create(sort))}>
        {name}
        <Layout.Inline.Component left>
          <Icon.Component sort={sort} />
        </Layout.Inline.Component>
      </Style>
    );
  };

  const Style = styled(Table.Header.Component)`
    cursor: pointer;
  `;

  namespace Icon {
    export const Component: React.Fn<Pick<Header, "sort">> = ({ sort }) =>
      sort.type !== sort.active.type ? (
        <Sort />
      ) : sort.active.direction === Document.Sort.Direction.descending() ? (
        <SortDown />
      ) : (
        <SortUp />
      );
  }
}
